import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ASSETS } from "@/lib/brand";

export function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis && typeof lenis.scrollTo === "function") {
    // Refresh Lenis's cached scroll limit in case layout changed (e.g. right after a route change)
    if (typeof lenis.resize === "function") lenis.resize();
    lenis.scrollTo(el, { offset: -80 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isHome = loc.pathname === "/";

  const goToSection = (id) => (e) => {
    e.preventDefault();
    if (isHome) {
      scrollToSection(id);
    } else {
      // Navigate home, then Home reads state and scrolls to the section
      navigate("/", { state: { scrollTo: id } });
    }
  };

  return (
    <nav
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#0A0A0A]/70 border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1600px] flex items-center justify-between px-6 md:px-12 py-5">
        <Link to="/" data-testid="nav-home-link" className="flex items-center gap-3">
          <img src={ASSETS.logo} alt="Watson Group" className="h-16 md:h-20 w-auto" />
        </Link>

        <div className="hidden md:flex items-center gap-10 text-[13px] tracking-[0.15em] uppercase text-white/70">
          <a href="/#about" onClick={goToSection("about")} className="gold-underline hover:text-white transition-colors">About</a>
          <a href="/#listings" onClick={goToSection("listings")} className="gold-underline hover:text-white transition-colors">Listings</a>
          <a href="/#news" onClick={goToSection("news")} className="gold-underline hover:text-white transition-colors">Journal</a>
          <Link to="/agents" data-testid="nav-agents-link" className="gold-underline hover:text-white transition-colors">Agents</Link>
        </div>

        <a
          href={isHome ? "#contact" : "/#contact"}
          onClick={goToSection("contact")}
          data-testid="nav-contact-button"
          className="group flex items-center gap-2 border border-white/20 hover:border-[#CBBFAE] rounded-full px-5 py-2.5 text-[12px] tracking-[0.2em] uppercase transition-colors"
        >
          <span>Contact</span>
          <span className="w-1.5 h-1.5 rounded-full bg-[#CBBFAE] group-hover:scale-125 transition-transform" />
        </a>
      </div>
    </nav>
  );
}
